import { render, staticRenderFns } from "./ObjetiveForm.vue?vue&type=template&id=09f40eae"
import script from "./ObjetiveForm.vue?vue&type=script&lang=js"
export * from "./ObjetiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports